import UiChevron from '@/components/ui/ui-chevron.vue';
import UiButton from '@/components/ui/ui-button.vue';
import UiMenu from '@/components/ui/ui-menu/index.vue';
import UiMenuContent from '@/components/ui/ui-menu/content.vue';
import UiSelect from '@/components/ui/ui-select/index.vue';
import UiSelectItem from '@/components/ui/ui-select/item.vue';
import UiInput from '@/components/ui/ui-input.vue';
import UiLabel from '@/components/ui/ui-label.vue';
import UiTooltipIcon from '@/components/ui/ui-tooltip-icon.vue';
import UiButtonMulti from '@/components/ui/ui-button-multi.vue';
import UiDatePicker from '@/components/ui/ui-date-picker.vue';
import UiInputTime from '@/components/ui/ui-input-time.vue';
import UiChip from '@/components/ui/ui-chip.vue';
import UiMenuContentItem from '@/components/ui/ui-menu/content-item.vue';
import UiPeriodPicker from '@/components/ui/ui-period-picker.vue';
import UiInputDetails from '@/components/ui/ui-input-details.vue';
import UiPeriodPickerInput from '@/components/ui/ui-period-picker-input.vue';
import UiDateTimePicker from '@/components/ui/ui-date-time-picker.vue';
import UiInfo from '@/components/ui/ui-info.vue';
import UiCheckbox from '@/components/ui/ui-checkbox.vue';
import UiRadio from '@/components/ui/ui-radio.vue';
import UiRadioGroup from '@/components/ui/ui-radio-group.vue';
import UiSwitcher from '@/components/ui/ui-switcher.vue';
import UiTextarea from '@/components/ui/ui-textarea.vue';
import UiTabs from '@/components/ui/ui-tabs.vue';
import UiIcon from '@/components/ui/ui-icon.vue';
import UiTreeview from '@/components/ui/ui-treeview.vue';
import UiPlanLimits from '@/components/ui/ui-plan-limits.vue';
import UiUpdateInfo from './ui-update-info.vue';
import UiCopyInput from './ui-copy-input.vue';
import UiCopyTextarea from './ui-copy-textarea.vue';
import UiCountInput from './ui-count-input.vue';
import UiCreateUrlTags from './ui-create-url-tags.vue';
import UiNotFound from './ui-not-found.vue';
import UiTable from './ui-table/table.vue';
import  UiPhoneInput from './ui-phone-input.vue';


export class UIService {
  install(Vue: any, options: any) { 
    Vue.component('ui-chevron', UiChevron);
    Vue.component('ui-button', UiButton);
    Vue.component('ui-menu', UiMenu);
    Vue.component('ui-menu-content', UiMenuContent);
    Vue.component('ui-select', UiSelect);
    Vue.component('ui-select-item', UiSelectItem);
    Vue.component('ui-input', UiInput);
    Vue.component('ui-label', UiLabel);
    Vue.component('ui-tooltip-icon', UiTooltipIcon);
    Vue.component('ui-button-multi', UiButtonMulti);
    Vue.component('ui-date-picker', UiDatePicker);
    Vue.component('ui-input-time', UiInputTime);
    Vue.component('ui-chip', UiChip);
    Vue.component('ui-menu-content-item', UiMenuContentItem);
    Vue.component('ui-period-picker', UiPeriodPicker);
    Vue.component('ui-input-details', UiInputDetails);
    Vue.component('ui-period-picker-input', UiPeriodPickerInput);
    Vue.component('ui-date-time-picker', UiDateTimePicker);
    Vue.component('ui-info', UiInfo);
    Vue.component('ui-checkbox', UiCheckbox);
    Vue.component('ui-radio', UiRadio);
    Vue.component('ui-radio-group', UiRadioGroup);
    Vue.component('ui-switcher', UiSwitcher);
    Vue.component('ui-textarea', UiTextarea);
    Vue.component('ui-icon', UiIcon);
    Vue.component('ui-plan-limits', UiPlanLimits);
    Vue.component('ui-treeview', UiTreeview);
    Vue.component('ui-update-info', UiUpdateInfo);
    Vue.component('ui-tabs', UiTabs);
    Vue.component('ui-copy-input', UiCopyInput);
    Vue.component('ui-copy-textarea', UiCopyTextarea);
    Vue.component('ui-count-input', UiCountInput);
    Vue.component('ui-create-url-tags', UiCreateUrlTags);
    Vue.component('ui-not-found', UiNotFound);
    Vue.component('ui-table', UiTable);
    Vue.component('ui-phone-input', UiPhoneInput);
  }
}

export default new UIService();
